import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { useContent } from "@/context/ContentContext";

const FIELDS = [
  { key: "org_name", label: "Nazwa organizacji" },
  { key: "tagline", label: "Krótki opis (tagline)", long: true },
  { key: "address", label: "Adres" },
  { key: "phone", label: "Telefon" },
  { key: "email", label: "E-mail" },
  { key: "krs", label: "Numer KRS" },
  { key: "hours", label: "Godziny pracy" },
  { key: "copyright", label: "Stopka copyright", long: true },
];

export default function AdminFooter() {
  const { reload } = useContent();
  const [data, setData] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/footer").then((r) => setData(r.data || {})).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/footer", { data });
      toast.success("Stopka zapisana");
      reload();
    } catch { toast.error("Błąd zapisu"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-ztk-navy dark:text-white">Edytor stopki</h2>
      <p className="mt-1 text-sm text-muted-foreground">Dane kontaktowe, KRS i tekst stopki</p>
      <div className="mt-8 max-w-2xl space-y-4 rounded-2xl border border-border bg-card p-6">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <Label>{f.label}</Label>
            {f.long
              ? <Textarea value={data[f.key] || ""} onChange={(e) => setData({ ...data, [f.key]: e.target.value })} data-testid={`footer-${f.key}`} className="mt-1.5" />
              : <Input value={data[f.key] || ""} onChange={(e) => setData({ ...data, [f.key]: e.target.value })} data-testid={`footer-${f.key}`} className="mt-1.5" />}
          </div>
        ))}
        <Button onClick={save} disabled={saving} className="gap-1.5 bg-ztk-blue" data-testid="admin-save-footer-button">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Zapisz stopkę
        </Button>
      </div>
    </div>
  );
}
